<script>
export default {
  name: "ForecastMatrixCell",
  props: {
    currentMonth: {
      type: String,
      default: null,
    },
    currentRevision: {
      type: Number,
      default: null,
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    hasPassed: {
      type: Boolean,
      default: false
    },
    isCurrent: {
      type: Boolean,
      default: false
    },
    interval: {
      type: Object,
      required: true
    },
    saving: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    }
  },
  computed: {
    hasError() {
      return !!this.error;
    },

    isInitial() {
      return this.interval.type === 'initial';
    },

    isRevision() {
      return this.interval.type === 'revised';
    },

    isActual() {
      return this.interval.type === 'actual';
    },

    isSubmitted() {
      return this.interval.submitted_at;
    },

    hasValue() {
      return this.interval.value !== null && this.interval.value !== undefined;
    },

    isEditable() {
      return this.canEdit && (this.isRevision || this.isInitial || this.isCurrent) && !this.isSubmitted;
    },

    inputID() {
      return `${this.interval.id}:${this.interval.key}:${this.interval.type}`;
    },

    stringValue() {
      return this.interval.value !== null && this.interval.value !== undefined
        ? this.interval.value.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : "--";
    }
  },
};
</script>

<template>
  <div
    :class="[
      'flex text-sm font-bold items-center justify-between py-2 border-l-4 border-grey-200',
      {
        'text-grey-700 bg-grey-100': hasPassed && !hasError,
        'bg-neutral-100': isEditable && !hasValue && !hasError,
        'bg-negative-100 text-negative-700': hasError,
      }
    ]"
    :style="{
      width: '6.25rem'
    }"
  >
    <template v-if="!isEditable">
      <span class="px-2">£</span>
      <span class="pr-2">{{ stringValue }}</span>
    </template>
    <template v-else>
      <span class="px-2">£</span>
      <input
        :id="inputID"
        v-model.number="interval.value"
        type="number"
        class="w-full text-right bg-transparent focus:outline-none p-0"
        inputmode="decimal"
        step="0.01"
        min="0"
        max="100000"
        :disabled="saving"
        placeholder="0.00"
        :readonly="readonly"
        @blur="$emit('update', {
          key: currentMonth,
          interval
        })"
      />
    </template>
  </div>
</template>
